import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { EMediaBreakpoint } from 'projects/shared/lib/enum/media/media-breakpoint.enum';
import { ServiceLocator } from 'projects/shared/lib/services/infrastructure/service-locator.service';
import { Subscription } from 'rxjs';
import { ENVIRONMENT } from 'projects/shared/lib/environment/environment';
import { Params } from '@angular/router';
import { CategoryNavBarComponent } from 'projects/shared/lib/components/shared/category/nav-bar/category-nav-bar.component';
import { IConfigurationServiceToken } from 'projects/shared/lib/services/infrastructure/configuration/configuration-service.interface';
import { IContextService, IContextServiceToken } from 'projects/shared/lib/services/infrastructure/context/context-service.interface';


@Component({
  selector: 'app-category-nav-bar',
  templateUrl: './category-nav-bar.component.html',
  standalone: false
})
export class CategoryNavBarMHComponent extends CategoryNavBarComponent implements OnInit, OnDestroy {
  private readonly contextService: IContextService = inject(IContextServiceToken);
  public activeComponent: string | undefined;

  private contextSubscription: Subscription | undefined;
  private context!: string;
  public isContextMyShop: boolean | undefined;
  public isMyShopVisible: boolean | undefined;

  public constructor() {
    super();

    this.brandPage = ENVIRONMENT.brandPage;
    ServiceLocator.injector.get(IConfigurationServiceToken).brandPageGet().subscribe((brandPage) => {
      if (this.brandPage != undefined) {
        this.brandPage.routerlink = brandPage.routerlink as string;
        let queryParams = new URLSearchParams(brandPage.queryParams);
        let queryParamsObject: Params = {};
        queryParams.forEach((value, key) => {
          queryParamsObject[key] = value;
        });
        this.brandPage.queryParams = queryParamsObject;
      }
    });

    let context = this.contextService.contextGet();
    this.contextUpdate(context);

    this.eMediaBreakpoint = EMediaBreakpoint;
    this.mediaBreakpoint = this.mediaService.mediaBreakpointGet();
  }

  public ngOnInit(): void {
    super.ngOnInit();
    let classRootContext = this.contextService.contextGet();
    this.isContextMyShop = classRootContext.localeCompare('myShop') == 0;
    this.productCategoryService.productCategoryTreeInitAsync();
    this.activeComponentSubscriptionInit();
    this.contextSubscriptionInit();
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
    this.contextSubscription?.unsubscribe();
  }

  protected activeComponentSubscriptionInit() {
    if (!this.activeComponentSubscription) {
      this.activeComponentSubscription = this.navigationService.activeComponentSubject.subscribe(
        (urlString) => {
          this.activeComponent = urlString;
          this.isCategoryNavBarVisible = urlString != undefined && (ENVIRONMENT.categoryNavbarVisibleRoutes?.find(route => urlString.indexOf(route) >= 0) != undefined);
          this.isMyShopVisible = urlString != undefined && (ENVIRONMENT.categoryNavbarVisibleRoutes?.find(route => urlString.indexOf(route) >= 0) != undefined);
          let queryParamKey = 'categoryKey';
          let startIndex = urlString?.indexOf(queryParamKey);
          if (startIndex != undefined && startIndex >= 0) {
            let queryParamOffset = queryParamKey.length + 1;
            let queryParamValueLength = 19;
            startIndex = startIndex + queryParamOffset;
            this.activeCategory = urlString?.substring(startIndex, startIndex + queryParamValueLength);
            return;
          }

          startIndex = urlString?.indexOf('promo');
          if (startIndex != undefined && startIndex >= 0) {
            this.activeCategory = urlString;
            return;
          }

          this.activeCategory = undefined;
        }
      );
    }
  }

  private contextSubscriptionInit() {
    if (!this.contextSubscription) {
      let classRootContext = this.contextService.contextGet();
      this.isContextMyShop = classRootContext.localeCompare('myShop') == 0;
      this.contextSubscription = this.contextService.contextChangeGet().subscribe(
        (context) => {
          setTimeout(() => {
            this.contextUpdate(context);
          });
        }
      );
    }
  }

  private contextUpdate(context: string) {
    if (this.context != undefined && this.context.localeCompare(context) == 0) {
      return;
    }

    this.context = context;
    this.isContextMyShop = this.context.localeCompare("myShop") == 0;
  }

}
